import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux/es/exports";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import { shop_data } from "../edit/data";

const SectionSevenThemeOne = () => {
  const settingsData: any = useSelector<any>((state) => state?.settings);
  const jsonData: any = useSelector<any>((state) => state?.shopHomeJsonList);
  // const jsonData: any = shop_data

  return (
    <>
      <section className="sh1-services-section" id="services-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="sh1-section-title" style={{
                      color: `#${jsonData?.theme_1?.home?.section_7?.h2color}`
                    }}>
              {jsonData?.theme_1?.home?.section_7?.title}
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="sh1-services-slider">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 4,
                    },
                    1024: {
                      slidesPerView: 6,
                    },
                  }}
                >
                  {jsonData?.theme_1?.home?.section_7?.card_section?.collection.map((item: any) => {
                      return (
                        <SwiperSlide>
                          <div className="sh1-services-slider-grid">
                            <img src={item.icon} alt="" />
                            <h5  style={{
                      color: `#${jsonData?.theme_1?.home?.section_7?.h3color}`
                    }}>{item.card_title}</h5>
                            {/* <p>There are many variations of passages of Lorem Ipsum available.</p> */}
                            <a
                              href="#bookNow"
                              className="btn sh1-btnslider hover-btn"
                            >
                              Book Now<i className="fas fa-chevron-right"></i>
                            </a>
                          </div>
                        </SwiperSlide>
                      );
                    })}
                </Swiper>
                {settingsData?.WebsiteSettings?.site_title_en.includes("Sasian") && (
                  <div className="sascallbtn py-5 text-center">
                    <a href="tel:+(44)7749300244" className="btn primary-btn">Call Us</a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SectionSevenThemeOne;
